<template>
    <v-footer app color="grey lighten-3">
        <v-spacer />
        <div class="text-caption">
            {{ appName }} {{ appVersion }} &copy; {{ new Date().getFullYear() }} Colours Factory Sp. z o.o.
        </div>
    </v-footer>
</template>

<script>
import { appConfig } from './../config.js'
export default {
    name: 'Footer',
    computed: {
        appName() {
            return appConfig.common.appName
        },
        appVersion() {
            return `v${appConfig.common.appVersion}`
        }
    }
}
</script>
